// extracted by mini-css-extract-plugin
export var active = "_9d-d";
export var blink = "_9d-e";
export var container = "_9d-5";
export var controls = "_9d-0";
export var controlsRight = "_9d-1";
export var fakeCursor = "_9d-c";
export var hidden = "_9d-b";
export var quillContainerSmall = "_9d-7";
export var quillEditor = "_9d-6";
export var quillEditorSmall = "_9d-8";
export var quillFormatButtons = "_9d-a";
export var quillToolbar = "_9d-9";
export var removePadding = "_9d-2";
export var state = "_9d-3";
export var stateTitle = "_9d-4";